import { IInference, IAstNode } from './typings';
import { TypeGenerator } from '../utils/type';
import { InferenceError } from '../errors';



export function inferenceNullComparison(inference: IInference, astNode: IAstNode) {
    const operator = astNode.operator!;

    const rightNode = astNode.right;
    const leftType = inference(astNode.left)!;

    if (!(rightNode.type === 'Atom' && rightNode.token && rightNode.token.isAtom && rightNode.token.code === 'NULL')) {
        throw new InferenceError('comparison-value-error', `${operator} 操作符左侧必须为\`NULL\``, rightNode.token.position);
    }

    if (['IS', 'IS-NOT'].includes(operator) && leftType.isArray) {
        throw new InferenceError('comparison-value-error', `数组不能使用 \`${astNode.token.raw} null\` 比较符`, astNode.left.token.position);
    }

    return TypeGenerator.Boolean();
}
